import React from "react";

export default function LayoutBottomFooter() {
  return (
    <div className="bottom-footer">
      <div className="container">
        <div className="row">
          {/* <div className="col-sm-8 copyright">
            <ul className="bottom-footer-links">
              <li>
                <span>about sf</span>
              </li>
              <li>
                <span>branches</span>
              </li>
              <li>
                <span>system types</span>
              </li>
              <li>
                <span>how to buy</span>
              </li>
              <li>
                <span>work with us</span>
              </li>
              <li>
                <span>contact us</span>
              </li>
            </ul>
            <span>
              {`© ${new Date().getFullYear()} SF Group. All rights reserved`}
            </span>
          </div> */}
        </div>
      </div>
    </div>
  );
}
